
import HeadBar from '../HeadBar/HeadBar';
import Calendar from '../Calendar/Calendar';
import Popup from 'vux/src/components/popup/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'popup-calendar',
components: {
XButton,
HeadBar,
Popup,
Calendar,
ViewBox,
},
props: {
value: {
type: Boolean,
default: false,
},
beginArr: {
type: Array,
defaul(){
return [];
}
},
endArr: {
type: Array,
default(){
return [];
}
}
},
data(){
return {
dateRange: {},
}
},
computed: {
isShowCalendar: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
},
}
},
watch: {
isShowCalendar(cur){
if(cur){
this.dateRange.start = this.beginArr;
this.dateRange.end = this.endArr;
}
}
},
methods: {
/** 隐藏日历 */
onHideCalendar(){
this.$emit('input', false);
},

/** 保存选择的日期 */
onGetDateWithRange(resp){
this.dateRange = resp;
},

/** 确定选择的日期 */
onConfirmDate(){
if(!this.dateRange.end[0]){
this.$vux.toast.show('请选择离店日期');
return false;
}
this.onHideCalendar();
this.$emit('on-get-date', this.dateRange);
},
},
}



// WEBPACK FOOTER //
// ./src/components/PopupCalendar/PopupCalendar.vue